import { Reveal, Overline } from "./Reveal";

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative py-16 lg:py-24 bg-[#FFFFFF]"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-center lg:gap-12">
        <div>
          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-[28px] border border-black/5 bg-white shadow-[0_24px_60px_rgba(17,17,17,0.06)]">
              <div className="relative aspect-[4/3]">
                <img
                  src="/processed_Cheerful Classroom Study Group.png"
                  alt="Students learning together in a cheerful classroom"
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/70 via-[#111111]/15 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="inline-flex items-center rounded-full bg-white/90 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#111111]">
                    Global outlook
                  </span>
                  <p className="mt-4 max-w-[220px] text-xl font-semibold leading-snug text-white">
                    Learning beyond borders, with clarity and purpose.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="flex flex-col gap-6">
          <Reveal>
            <Overline testid="about-overline">WHY WE EXIST</Overline>
            <h2
              data-testid="about-heading"
              className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-[#111111]"
            >
              Because every student deserves a mentor who understands their
              ambitions.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-base sm:text-lg text-[#111111] leading-relaxed">
              At Movementor, mentoring begins with understanding you—your
              interests, ambitions and what you want from life after graduation.
              Whether you want to deepen your expertise through research or gain
              experience in your chosen profession, we help you make informed
              study-abroad choices. We believe international education should
              open up new horizons—introducing you to different cultures, fresh
              perspectives and possibilities you may never have imagined.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <blockquote
              data-testid="about-vision-quote"
              className="relative mt-2 pl-8 border-l-4 border-transparent [border-image:linear-gradient(180deg,#FE7815,#F01E1F)_1]"
            >
              <p className="text-xl sm:text-2xl font-bold text-[#111111] leading-snug">
                "Vasudhaiva Kutumbakam"
              </p>
              <p className="mt-2 text-sm sm:text-base text-[#111111]">
                The world is one family — the philosophy that sits beneath
                everything we do.
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
